export enum ErrorType {
    Success,
    LocalError,
    UserError,
    ServerError,
}